/* Ayudate · Avatar del tutor */

import React from "react";

export function Avatar({ tutor, size = 46 }) {
  const pendiente = tutor.estado === "pendiente";
  const conFoto = !pendiente && tutor.foto;
  return (
    <div className={`av ${pendiente ? "esperando" : ""}`}
      style={{ width: size, height: size }}
      title={pendiente ? "Perfil en revisión" : tutor.nom}>
      {conFoto ? (
        <img src={tutor.foto} alt="" />
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="avic">
          <circle cx="12" cy="8.6" r="3.9" fill="currentColor" />
          <path d="M4.4 20.4c0-3.9 3.4-6.5 7.6-6.5s7.6 2.6 7.6 6.5" fill="currentColor" />
        </svg>
      )}
      {pendiente && (
        <span className="avesp" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="9.2" fill="none" stroke="currentColor" strokeWidth="2.2" />
            <path d="M12 6.8V12l3.4 2.1" stroke="currentColor" strokeWidth="2.2"
              strokeLinecap="round" fill="none" />
          </svg>
        </span>
      )}
    </div>
  );
}

/* ------------------------------------------------------------------
   Capa base de todas las ventanas emergentes.

   Va anclada a la pantalla, no al documento, así que aparece siempre
   donde esté la persona sin importar cuánto haya bajado. Si el contenido
   es más alto que la pantalla, se desplaza dentro de la propia capa: eso
   evita que la parte de arriba quede fuera de alcance, que era lo que
   obligaba a subir a buscarla. Mientras está abierta:
     · la página de atrás no se puede desplazar
     · el tabulador no se sale del diálogo
     · Escape la cierra y el foco vuelve a donde estaba
------------------------------------------------------------------- */
/* El bloqueo se lleva con un contador porque las ventanas se anidan: el aviso
   de políticas se abre encima de la solicitud. Sin contador, la de adentro
   restauraba el scroll al cerrarse y la de afuera quedaba trabada.          */
